import { API_G_110_SEIKYU_LIST } from '@/constants/api';
import axios from '@/plugins/axios';
import { removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

const g_110: Module<unknown, unknown> = {
  namespaced: true,
  state() {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getSeikyuList(_ctx, params) {
      try {
        const res = await axios({
          url: API_G_110_SEIKYU_LIST,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getSeikyuList error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putSeikyuList(_ctx, params) {
      try {
        const res = await axios({
          url: API_G_110_SEIKYU_LIST,
          method: 'PUT',
          params: params,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putSeikyuList error.');
        console.log(err);
      }
    },
  },
};

export default g_110;
